
import breakpointMixin from '~/mixins/breakpoints'
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok?.background
      styles.borderRadius = this.getBreakpointValue(this.blok?.borderRadius)
      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)
      styles.height = this.getBreakpointValue(this.blok?.height)

      return styles
    },
  },
}
